
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const fetchSingleBook = createAsyncThunk('singleBook/fetchSingleBook', async (id) => {
  const url = `https://secureadmin.lkwb.com.np/api/home/all-books/${id}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch single book. Status: ${response.status}`);
  }
  const data = await response.json();
  return data.data;
});

const singleBookslice = createSlice({
  name: 'singleBook',
  initialState: { data: {}, loading: 'idle', error: null },
  reducers: {


  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchSingleBook.pending, (state) => {
        state.loading = 'loading';
      })
      .addCase(fetchSingleBook.fulfilled, (state, action) => {
        state.loading = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchSingleBook.rejected, (state, action) => {
        state.loading = 'failed';
        state.error = action.error.message;
      });
  },
});

export default singleBookslice.reducer;
